module.exports = {"id":"189606","name":"Julian Baumgartlinger","rating":"78","photo":"./data/images/photos/2/189606.png","club":{"name":"Bayer 04","logo":"./data/images/clubs/Bayer04.png"},"positions":["MDC"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/JulianBaumgartlinger0.json
// module id = 2234
// module chunks = 0